import React, { useState } from 'react';
import LazyImage from '../../../components/CustomLibraries/LazyImage';
import './css/ebookCard.scss';
const EbookCard = ({ click, image, gtmTagVariable = '', id }) => {
  return (
    <div
      className="w-100 float-start ebookV1Box cursorPointer position-relative rounded-3 overflow-hidden"
      onClick={click}
    >
      <div className="w-100 ebookV1BoxIn bg-white position-relative shadow z-1">
        {image ? (
          <img
            src={image}
            alt="Book Cover"
            className={`object-fit-cover w-100 h-auto float-start 
            ${gtmTagVariable}_ebookCard_image`}
          />
        ) : (
          <img
            src="https://www.adobe.com/express/learn/blog/media_1abf7fbb4425886120f3dec037f4733b142492fe9.png?width=2000&format=webply&optimize=medium"
            alt="Book Cover"
            className={`object-fit-cover w-100 h-auto float-start
             ${gtmTagVariable}_ebookCard_image`}
          />
        )}
      </div>
    </div>
  );
};

export default EbookCard;
